import { Pipe, PipeTransform } from '@angular/core';
import { getTariffClassWithLineBreaks } from '@mwe/utils';

@Pipe({ name: 'tariffClassLineBreak', })
export class TariffClassLineBreakPipe implements PipeTransform {
  transform(tariffClass: string | string[]): string | string[] {
    return getTariffClassWithLineBreaks(tariffClass);
  }
}
